const REFRESH = 'FEATURE_FLAG_REFRESH';

export default {
  REFRESH,
};
